import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const AdminGetRoom = async () => {
  try {
    const response = await APIs.get(`/get_my_admin_rooms`);

    if (response?.data?.message?.toLowerCase() === 'success') {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

const AdminGetNormalRoom = async () => {
  try {
    const response = await APIs.get(`/get_my_normal_admin_rooms`);

    if (response?.data?.message?.toLowerCase() === 'success') {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

const AdminUploadImages = async (payload) => {
  try {
    const response = await APIs.post(
      `/cloudinary_multiple_file_upload`,
      payload
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const RoomServices = {
  AdminGetRoom,
  AdminUploadImages,
  AdminGetNormalRoom,
};

export default RoomServices;
